import React from "react";

import { BSC, getConstant } from "config/chains";

import StakeV1 from "./StakeV1";
import StakeV2 from "./StakeV2";

export default function Stake(props) {
  const chainId = BSC;
  const isV2 = getConstant(chainId, "v2");
  // return isV2 ? <StakeV2 {...props} /> : <StakeV1 {...props} />;
  return <StakeV2 {...props} />
}
